import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/reportes/gastos';

import Gastos from './Gastos';
import {resetStore} from "../../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.reporte_gastos,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(Gastos);
